import { gql } from '@apollo/client';

export const DELETE_ADMIN_INSTITUTION = gql`
  mutation deleteAdminInstitution($id: ID!) {
    institution: deleteAdminInstitution(id: $id) {
      id
      name
    }
  }
`;
